<div oui-dialog-title>
  Résilier l'abonnement au bouquet de services
  <oui-button
    type="icon"
    color="secondary"
    (click)="close()">
    <oui-icon>close</oui-icon>
  </oui-button>
</div>
<oui-dialog-content>
  <div class="dialog-content">
    <section class="dialog-intro">
      <p class="eyebrow">Consultant #{{ consultantId }}</p>
      <h5>{{ consultantLabel }}</h5>
    </section>

    <oui-date-picker
      class="termination-date-field"
      label="Date effective de résiliation"
      [control]="terminationDateControl">
    </oui-date-picker>
  </div>
</oui-dialog-content>

<oui-dialog-actions>
  <oui-button
    type="outlined"
    (click)="close()"
    >Annuler</oui-button
  >
  <oui-button
    [disabled]="!canSubmit"
    (click)="confirm()">
    Résilier
  </oui-button>
</oui-dialog-actions>
